/**
 * @module Utilities/Strings
 * @desc Strings helper funtions
 */
import format from 'string-format';

import type { Utilities } from 'core/domains';

/**
 * Format string interpolation is replacing placeholders with values in a string literal.
 */
export function formatString(text = '', options: Utilities.PlainObject = {}) {
  return format(text, options);
}
